import {Button, Stack, Text} from "@mantine/core";
import {HomeSellingOptionsForm} from "features/homes/components/home.selling-options/home.selling-options.form";
import {useModals} from "@mantine/modals";
import {
    IHomeSellingOptionSubmitValues
} from "features/homes/components/home.selling-options/home.selling-options.types";
import {useParams} from "react-router-dom";
import {homeHooks} from "features/homes/hooks";
import {EUserEventType} from "features/homes/types";

interface Props {
    onSubmitForm:(values:IHomeSellingOptionSubmitValues) => void,
}

export function HomeSellingOptionsButton({ onSubmitForm }:Props) {
    const modals = useModals();
    const {homeId} = useParams()
    const {mutateAsync: sendUserClickEvent} = homeHooks.useUserClickEvent()
    async function _onSubmitForm(values:IHomeSellingOptionSubmitValues){
        await onSubmitForm(values);
        modals.closeAll();
    }

    const renderHomeForm = () => {
        sendUserClickEvent({eventType: EUserEventType.ViewedSellingOptions, homeId: parseInt(homeId!)})
        modals.openModal({
            withCloseButton:true,
            closeOnClickOutside:true,
            closeOnEscape:true,
            centered:true,
            overflow:'outside',
            size:"auto",
            title: (
                <Stack spacing={3}>
                    <Text style={{fontSize:16}} weight={600}>Choose Your Selling Option</Text>
                    <Text style={{fontSize:12}} color="dimmed" size="xs">Find the perfect solution for your home sale</Text>
                </Stack>
            ),
            children: (
                <HomeSellingOptionsForm onSubmitQuery={_onSubmitForm}/>
            ),
        })
        return false;
    }

    return (
        <Button size="xs" onClick={renderHomeForm}>
            Explore Selling Options
        </Button>
    )
}
